<template>
  <div class="app-container">
    <div class="page-header">
      <h3>分组管理</h3>
    </div>
    <div class="search-bar">
      <el-form :inline="true" :model="searchParams">
        <el-form-item>
          <el-input v-model="searchParams.name" placeholder="分组名称" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button type="success" icon="el-icon-plus" @click="openCreateDialog">新增分组</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data-table">
      <el-table :data="groups" border fit style="width: 100%" :cell-style="centerCellStyle"
        :header-cell-style="centerHeaderStyle">
        <el-table-column type="index" width="60" align="center" />
        <el-table-column prop="id" label="分组ID" min-width="100" align="center" />
        <el-table-column prop="group_name" label="分组名称" min-width="220" align="center" />
        <el-table-column prop="company_id" label="公司ID" min-width="120" align="center" />
        <el-table-column prop="created_at" label="创建时间" min-width="180" align="center" />
        <el-table-column prop="updated_at" label="更新时间" min-width="180" align="center" />
        <el-table-column label="操作" min-width="300" fixed="right" align="center">
          <template slot-scope="{row}">
            <div class="action-buttons">
              <el-button size="mini" type="primary" plain @click="openGroupUsers(row)">人员管理</el-button>
              <el-button size="mini" type="success" plain @click="openGroupBoxes(row)">回收箱管理</el-button>
              <el-button size="mini" type="info" plain @click="openEditDialog(row)">编辑</el-button>
              <el-button size="mini" type="danger" plain @click="handleDelete(row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
        :page-sizes="[10, 20, 50, 100]" :current-page="searchParams.page" :page-size="searchParams.page_size"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form ref="groupFormRef" :model="groupForm" :rules="groupRules" label-width="80px">
        <el-form-item label="分组名称" prop="group_name">
          <el-input v-model="groupForm.group_name" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitGroup">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="回收箱管理" :visible.sync="groupDevicesDialogVisible" width="1100px">
      <div style="margin-bottom:10px;color:#606266">当前分组：{{ currentGroup && currentGroup.group_name }}（ID: {{ currentGroup && currentGroup.id }}）</div>
      <div style="margin-bottom:8px;">
        <el-input v-model="deviceSearchName" placeholder="设备名称" clearable style="width:260px;margin-right:8px;" @keyup.enter.native="loadDevicesTransferData" />
        <el-button type="primary" icon="el-icon-search" @click="loadDevicesTransferData">搜索</el-button>
      </div>
      <el-transfer
        v-loading="devicesLoading"
        class="group-devices-transfer"
        v-model="deviceTransferTargetKeys"
        :data="deviceTransferData"
        filterable
        :filter-placeholder="'请输入'"
        :titles="['设备列表', '组内设备']"
        :props="{ key: 'key', label: 'label' }"
        :render-content="renderDeviceTransferItem"
        @change="handleDeviceTransferChange"
        style="width: 100%;"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="groupDevicesDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmDevicesSelection">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="人员管理" :visible.sync="groupUsersDialogVisible" width="1000px">
      <div style="margin-bottom:10px;color:#606266">当前分组：{{ currentGroup && currentGroup.group_name }}（ID: {{ currentGroup && currentGroup.id }}）</div>
      <el-transfer
        v-loading="usersLoading"
        class="group-users-transfer"
        v-model="transferTargetKeys"
        :data="transferData"
        filterable
        :filter-placeholder="'请输入'"
        :titles="['员工列表', '组内成员']"
        :props="{ key: 'key', label: 'label' }"
        :render-content="renderTransferItem"
        @change="handleTransferChange"
        style="width: 100%;"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="groupUsersDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmUsersSelection">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCleaningGroups, createCleaningGroup, updateCleaningGroup, deleteCleaningGroup } from '@/api/cleaningGroups'
import { getUserList } from '@/api/users'
import request from '@/api/interceptor'
export default {
  name: 'CleaningGroups',
  data() {
    return {
      loading: false,
      searchParams: { group_name: '', page: 1, page_size: 10 },
      total: 0,
      groups: [],
      dialogVisible: false,
      dialogTitle: '新增分组',
      groupForm: { id: '', group_name: '' },
      groupRules: { group_name: [{ required: true, message: '请输入分组名称', trigger: 'blur' }] }
      ,
      groupUsersDialogVisible: false,
      currentGroup: null,
      usersLoading: false,
      usersPagination: { page: 1, page_size: 20 },
      usersTotal: 0,
      transferData: [],
      transferTargetKeys: [],
      originalMemberIds: [],
      memberIdByCleanerId: {}
      ,
      groupDevicesDialogVisible: false,
      devicesLoading: false,
      deviceSearchName: '',
      deviceTransferData: [],
      deviceTransferTargetKeys: [],
      deviceOriginalIds: [],
      deviceRelationIdByDeviceId: {}
    }
  },
  created() {
    this.fetchGroups()
  },
  methods: {
    centerCellStyle() { return { textAlign: 'center' } },
    centerHeaderStyle() { return { textAlign: 'center' } },
    async fetchGroups() {
      try {
        this.loading = true
        const params = { page: this.searchParams.page, page_size: this.searchParams.page_size }
        if (this.searchParams.group_name) params.group_name = this.searchParams.group_name
        const res = await getCleaningGroups(params)
        const outer = res && res.data ? res.data : res
        const inner = outer && outer.data ? outer.data : outer
        const payload = inner && inner.data ? inner.data : inner
        const groups = Array.isArray(payload && payload.groups) ? payload.groups : []
        const total = Number(payload && payload.total) || 0
        this.groups = groups
        this.total = total
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.searchParams.page = 1; this.fetchGroups() },
    handleReset() { this.searchParams = { group_name: '', page: 1, page_size: 10 }; this.fetchGroups() },
    handleSizeChange(size) { this.searchParams.page_size = size; this.fetchGroups() },
    handleCurrentChange(current) { this.searchParams.page = current; this.fetchGroups() },
    openCreateDialog() { this.dialogTitle = '新增分组'; this.groupForm = { id: '', group_name: '' }; this.dialogVisible = true },
    openEditDialog(row) { this.dialogTitle = '编辑分组'; this.groupForm = { id: row.id, group_name: row.group_name || '' }; this.dialogVisible = true },
    async submitGroup() {
      const valid = await new Promise(r => { if (!this.$refs.groupFormRef) return r(true); this.$refs.groupFormRef.validate(v => r(v)) })
      if (!valid) return
      if (this.groupForm.id) {
        await updateCleaningGroup(this.groupForm.id, { name: this.groupForm.group_name })
        this.$message.success('更新成功')
      } else {
        await createCleaningGroup({ name: this.groupForm.group_name })
        this.$message.success('创建成功')
      }
      this.dialogVisible = false
      this.fetchGroups()
    },
    // 跳转：根据菜单标题解析路由
    resolveMenuPathByTitle(title) {
      try {
        const routes = (this.$router && this.$router.options && this.$router.options.routes) || []
        const layout = routes.find(r => r.path === '/')
        const children = (layout && layout.children) || []
        const hit = children.find(c => c.meta && c.meta.title === title)
        return hit ? `/${hit.path}`.replace(/\/+/, '/') : null
      } catch (e) {
        return null
      }
    },
    openGroupUsers(row) {
      this.currentGroup = row
      this.groupUsersDialogVisible = true
      this.usersPagination.page = 1
      this.loadUsersTransferData()
    },
    openGroupBoxes(row) {
      this.currentGroup = row
      this.groupDevicesDialogVisible = true
      this.loadDevicesTransferData()
    },
    async fetchStaffUsers() {
      try {
        this.usersLoading = true
        const page_size = 10
        let page = 1
        const all = []
        let total = 0
        let continueLoop = true
        while (continueLoop) {
          const params = { page, page_size: page_size, role: 1 }
          const res = await getUserList(params)
          const body = res && res.data ? res.data : res
          const list = Array.isArray(body && body.users) ? body.users : (Array.isArray(body && body.data) ? body.data : [])
          const pageTotal = Number(body && (body.total || (body.pagination && body.pagination.total))) || 0
          if (pageTotal) total = pageTotal
          if (Array.isArray(list) && list.length > 0) {
            all.push(...list)
          }
          continueLoop = Array.isArray(list) && list.length === page_size
          page += 1
        }
        return { employees: all, total: total || all.length }
      } finally {
        this.usersLoading = false
      }
    },
    async fetchGroupMembers() {
      try {
        this.usersLoading = true
        const page_size = 10
        let page = 1
        const all = []
        let continueLoop = true
        while (continueLoop) {
          const params = { page, pages_size: page_size, group_id: this.currentGroup && this.currentGroup.id }
          const res = await request({ url: '/v1/cleaner-groups', method: 'get', params })
          const outer = res && res.data ? res.data : res
          const inner = outer && outer.data ? outer.data : outer
          const payload = inner && inner.data ? inner.data : inner
          const list = payload && payload.groups ? payload.groups : []
          if (Array.isArray(list) && list.length > 0) {
            all.push(...list)
          }
          continueLoop = Array.isArray(list) && list.length === page_size
          page += 1
        }
        return all
      } finally {
        this.usersLoading = false
      }
    },
    async loadUsersTransferData() {
      try {
        this.usersLoading = true
        const [members, staffRes] = await Promise.all([this.fetchGroupMembers(), this.fetchStaffUsers()])
        const employees = (staffRes && staffRes.employees) || []
        this.usersTotal = (staffRes && staffRes.total) || employees.length
        const memberIds = new Set((members || []).map(m => m.cleaner_id))
        this.originalMemberIds = Array.from(memberIds)
        this.memberIdByCleanerId = {}
        const map = new Map()
        // 组内成员（右侧必须显示）
        ;(members || []).forEach(m => {
          const key = m.cleaner_id
          const existing = map.get(key) || {}
          this.memberIdByCleanerId[m.cleaner_id] = m.id
          map.set(key, { ...existing, key, cleaner_id: m.cleaner_id, cleaner_name: m.cleaner_name })
        })
        // 员工列表（左侧显示，不包含已在右侧的）
        ;(employees || []).forEach(e => {
          const key = e.id
          if (memberIds.has(key)) {
            const existing = map.get(key) || {}
            map.set(key, { ...existing, key, id: e.id, real_name: e.real_name })
          } else {
            map.set(key, { key, id: e.id, real_name: e.real_name })
          }
        })
        this.transferData = Array.from(map.values())
        this.transferTargetKeys = Array.from(memberIds)
      } catch (e) {
        this.transferData = []
        this.transferTargetKeys = []
        this.originalMemberIds = []
      } finally {
        this.usersLoading = false
      }
    },
    handleTransferChange(newTargetKeys) {
      this.transferTargetKeys = newTargetKeys
    },
    renderTransferItem(h, option) {
      const inRight = Array.isArray(this.transferTargetKeys) && this.transferTargetKeys.indexOf(option.key) !== -1
      const label = inRight
        ? `编号：${option.cleaner_id || option.key}，姓名：${option.cleaner_name || option.real_name || ''}`
        : `编号：${option.id || option.key}，姓名：${option.real_name || option.cleaner_name || ''}`
      return h('span', { style: { whiteSpace: 'normal', wordBreak: 'break-all' } }, label)
    },
    async confirmUsersSelection() {
      const current = new Set(this.transferTargetKeys)
      const original = new Set(this.originalMemberIds)
      const toAdd = Array.from(current).filter(id => !original.has(id))
      const toRemove = Array.from(original).filter(id => !current.has(id))
      try {
        // 添加：/v1/cleaner-groups POST { cleaner_id, group_id }
        for (const cleanerId of toAdd) {
          await request({
            url: '/v1/cleaner-groups',
            method: 'post',
            data: { cleaner_id: cleanerId, group_id: this.currentGroup && this.currentGroup.id }
          })
        }
        // 移除：/v1/cleaner-groups/delete POST { id }
        for (const cleanerId of toRemove) {
          const membershipId = this.memberIdByCleanerId[cleanerId]
          if (!membershipId) continue
          await request({
            url: '/v1/cleaner-groups/delete',
            method: 'get',
            params: { id: membershipId }
          })
        }
        this.$message.success('人员编辑成功')
        this.groupUsersDialogVisible = false
        this.loadUsersTransferData()
      } catch (e) {
        this.$message.error('人员编辑失败，请稍后重试')
      }
    },
    async fetchGroupDevices() {
      try {
        this.devicesLoading = true
        const page_size = 10
        let page = 1
        const all = []
        let continueLoop = true
        while (continueLoop) {
          const params = { page, page_size: page_size, group_id: this.currentGroup && this.currentGroup.id }
          const res = await request({ url: '/v1/box-group-devices', method: 'get', params })
          const outer = res && res.data ? res.data : res
          const inner = outer && outer.data ? outer.data : outer
          const payload = inner && inner.data ? inner.data : inner
          const list = payload && payload.relations ? payload.relations : []
          if (Array.isArray(list) && list.length > 0) {
            all.push(...list)
          }
          continueLoop = Array.isArray(list) && list.length === page_size
          page += 1
        }
        return all
      } finally {
        this.devicesLoading = false
      }
    },
    async fetchDevicesList() {
      try {
        this.devicesLoading = true
        const page_size = 10
        let page = 1
        const all = []
        let continueLoop = true
        while (continueLoop) {
          const params = { page, page_size: page_size }
          if (this.deviceSearchName) params.device_name = this.deviceSearchName
          const res = await request({ url: '/v1/devices', method: 'get', params })
          const body = res && res.data ? res.data : res
          const list = Array.isArray(body && body.devices) ? body.devices : (Array.isArray(body && body.data) ? body.data : [])
          if (Array.isArray(list) && list.length > 0) {
            all.push(...list)
          }
          continueLoop = Array.isArray(list) && list.length === page_size
          page += 1
        }
        return all
      } finally {
        this.devicesLoading = false
      }
    },
    async loadDevicesTransferData() {
      try {
        this.devicesLoading = true
        const [relations, devices] = await Promise.all([this.fetchGroupDevices(), this.fetchDevicesList()])
        const memberIds = new Set((relations || []).map(r => r.device_id))
        this.deviceOriginalIds = Array.from(memberIds)
        this.deviceRelationIdByDeviceId = {}
        const map = new Map()
        ;(relations || []).forEach(r => {
          const key = r.device_id
          const existing = map.get(key) || {}
          this.deviceRelationIdByDeviceId[r.device_id] = r.id
          map.set(key, { ...existing, key, device_id: r.device_id, device_name: r.device_name })
        })
        const availableDevices = (devices || []).filter(d => {
          const g = d.groups
          if (g === '[]') return true
          if (Array.isArray(g) && g.length === 0) return true
          if (typeof g === 'string') {
            try {
              const parsed = JSON.parse(g)
              if (Array.isArray(parsed) && parsed.length === 0) return true
            } catch (e) { /* ignore parse error */ }
          }
          return false
        })
        ;(availableDevices || []).forEach(d => {
          const key = d.id
          if (memberIds.has(key)) {
            const existing = map.get(key) || {}
            map.set(key, { ...existing, key, id: d.id, device_name: d.container_name || d.device_name || d.name })
          } else {
            map.set(key, { key, id: d.id, device_name: d.container_name || d.device_name || d.name })
          }
        })
        this.deviceTransferData = Array.from(map.values())
        this.deviceTransferTargetKeys = Array.from(memberIds)
      } catch (e) {
        this.deviceTransferData = []
        this.deviceTransferTargetKeys = []
        this.deviceOriginalIds = []
        this.deviceRelationIdByDeviceId = {}
      } finally {
        this.devicesLoading = false
      }
    },
    handleDeviceTransferChange(newTargetKeys) {
      this.deviceTransferTargetKeys = newTargetKeys
    },
    renderDeviceTransferItem(h, option) {
      const inRight = Array.isArray(this.deviceTransferTargetKeys) && this.deviceTransferTargetKeys.indexOf(option.key) !== -1
      const label = inRight
        ? `编号：${option.device_id || option.key}，名称：${option.device_name || ''}`
        : `编号：${option.id || option.key}，名称：${option.device_name || ''}`
      return h('span', { style: { whiteSpace: 'normal', wordBreak: 'break-all' } }, label)
    },
    async confirmDevicesSelection() {
      const current = new Set(this.deviceTransferTargetKeys)
      const original = new Set(this.deviceOriginalIds)
      const toAdd = Array.from(current).filter(id => !original.has(id))
      const toRemove = Array.from(original).filter(id => !current.has(id))
      try {
        for (const deviceId of toAdd) {
          await request({
            url: '/v1/box-group-devices',
            method: 'post',
            data: { device_id: deviceId, group_id: this.currentGroup && this.currentGroup.id }
          })
        }
        for (const deviceId of toRemove) {
          const relationId = this.deviceRelationIdByDeviceId[deviceId]
          if (!relationId) continue
          await request({
            url: `/v1/box-group-devices/${relationId}`,
            method: 'get'
          })
        }
        this.$message.success('设备编辑成功')
        this.groupDevicesDialogVisible = false
        this.loadDevicesTransferData()
      } catch (e) {
        this.$message.error('设备编辑失败，请稍后重试')
      }
    },
    async handleDelete(row) {
      this.$confirm(`确定删除分组 ${row.group_name || row.name} 吗？`, '提示', { type: 'warning' }).then(async () => {
        await deleteCleaningGroup(row.id)
        this.$message.success('删除成功')
        this.fetchGroups()
      }).catch(() => { })
    }
  }
}
</script>

<style scoped>
.app-container {
  background-color: #f0f2f5;
  padding: 20px;
}

.page-header {
  background: #fff;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.page-header h3 {
  margin: 0;
  font-size: 16px;
  color: #303133;
}

.search-bar {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.data-table {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
}

.action-buttons {
  display: inline-flex;
  gap: 8px;
  align-items: center;
}

.pagination-wrapper {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-top: 12px;
  text-align: right;
}

.group-users-transfer::v-deep .el-transfer-panel {
  width: 380px;
}
.group-users-transfer::v-deep .el-transfer-panel__item .el-checkbox__label {
  white-space: normal;
  word-break: break-all;
  overflow: visible;
  text-overflow: clip;
}

.group-devices-transfer::v-deep .el-transfer-panel {
  width: 380px;
}
.group-devices-transfer::v-deep .el-transfer-panel__item .el-checkbox__label {
  white-space: normal;
  word-break: break-all;
  overflow: visible;
  text-overflow: clip;
}
</style>
